import Layout from '../../components/Layout';
import React, { useEffect, useState } from 'react';

import { BsSearch } from 'react-icons/bs';
import { getResolvedPath } from '../../utils';
import { artService } from '../../services/artwork.service';
import { useNavigate, useParams } from 'react-router-dom';
import { safetyService } from '../../services/safety.service';
import { Button } from '@material-ui/core';
import { openSnackBar } from '../../redux/snackBarReducer';
import { useDispatch } from 'react-redux';
import SafetyResultCard from '../../components/SafetyResultCard';
import ArtImageFallback from '../../components/ArtImageFallback';

const ArtworkURL = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { artworkId } = useParams();
  const [artwork, setArtwork] = useState({});
  const [imgUrl, setImgUrl] = useState('');
  const [resultImgList, setResultImgList] = useState([]);
  const [update, setUpdate] = useState('');

  const init = async () => {
    const resp = await artService.getArtwork(artworkId);
    if (resp.status !== 'success' || !resp.artwork) return;

    const record = Array.isArray(resp.artwork) ? resp.artwork[0] : resp.artwork;
    const withArtist = {
      ...record,
      userDetails: resp.artist ? [resp.artist] : record.userDetails || [],
    };
    setArtwork(withArtist);
    if (record.images?.[0]) {
      setImgUrl(getResolvedPath(record.images[0]));
    }
  };

  const getOneSafetyInfo = async () => {
    dispatch(openSnackBar({ message: 'Loading image searching result from the database', status: 'info' }));
    const resp = await safetyService.getOneSafetyInfo(artworkId);
    if (resp.success) {
      dispatch(openSnackBar({ message: 'loaded data from the database successfully', status: 'success' }));
      setResultImgList(resp.oneSafety.imageResult || []);
      setUpdate(resp.oneSafety.updatedAt);
    } else {
      dispatch(openSnackBar({ message: 'There is no data for this artwork', status: 'warning' }));
    }
  };

  const clickSearchBtn = async () => {
    dispatch(openSnackBar({ message: 'Loading image searching result', status: 'info' }));
    try {
      const resp = await safetyService.sendSearchRequest(artworkId, imgUrl);
      setResultImgList(resp.oneSafety?.imageResult || []);
      setUpdate(resp.oneSafety?.updatedAt);
      dispatch(openSnackBar({ message: 'Successfully loaded', status: 'success' }));
    } catch (err) {
      dispatch(openSnackBar({ message: err.message || 'Search failed', status: 'error' }));
    }
  };

  useEffect(() => {
    init();
    getOneSafetyInfo();
  }, []);

  return (
    <Layout>
      <div className="mt-10">
        <div className="m-auto justify-between lg:flex">
          <div className="m-auto p-16 bg-gray-200 w-11/12 lg:flex">
            <ArtImageFallback
              src={imgUrl}
              alt={artwork.name || ''}
              className="object-contain max-w-full max-h-full"
              wrapperStyle={{ width: 400, height: 280, minHeight: 200 }}
            />
            <div className="leading-9 mt-4 lg:ml-16">
              <h2 className="text-lg text-red-600 my-2 font-bold">{artwork.name || '—'}</h2>
              <p className="text-lg font-bold">
                {artwork.userDetails?.length &&
                  artwork.userDetails[0].firstname + ' ' + artwork.userDetails[0].lastname}
              </p>
              <p className="text-sm text-gray-500">PRICE: {artwork.listed_price}</p>
              <p className="text-sm text-gray-500">
                Primary Colors:{' '}
                {artwork.colorlist?.map((item, key) => (
                  <span key={key}>{item + ' '}</span>
                ))}
              </p>

              <div className="flex mt-3 space-x-4">
                <Button style={{ backgroundColor: 'green' }} variant="contained" onClick={clickSearchBtn}>
                  <BsSearch /> &nbsp; Search By URL
                </Button>
                <Button variant="contained" onClick={() => navigate('/')}>
                  Back
                </Button>
                <Button color="secondary" variant="contained" onClick={() => navigate(`/artwork/name/${artworkId}`)}>
                  Go To Name Search
                </Button>
              </div>

              <p className="text-sm text-red-500 mt-2">Updated Time : {update}</p>
              <p className="text-lg text-blue-600 mt-4 font-bold">About</p>
              <div className="mt-2 leading-9">
                <p>Publication: {artwork.publication}</p>
                <p>Description: {artwork.description}</p>
                <p>Location: {artwork.location}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex m-auto bg-gray-200 mt-16 p-8 w-11/12">
          <ul className="m-auto w-11/12 h-[700px] overflow-auto">
            {resultImgList.map((item, key) => (
              <li className="p-2" key={key}>
                <SafetyResultCard item={item} />
              </li>
            ))}
          </ul>
          {resultImgList.length === 0 ? (
            <h1 className="text-red-400">No Result</h1>
          ) : (
            <h1>Results: {resultImgList.length}</h1>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default ArtworkURL;
